import { sizes } from "../hocs/Responsive";
import { FOOTER_CLASS_NAME } from "../components/layout/footer/Footer";
import { TopOffsetElements } from "../store/layout";

const MOBILE_BREAKPOINT = sizes.tabletMin;
const DEFAULT_NOTIFICATION_OFFSET = 12;

export function isMobile(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export const getTopOffsetLayout = (
  topOffsetElements: TopOffsetElements
): number => {
  const {
    headerHeight,
    primaryNavigationHeight,
    staticNotificationHeight,
    eulaHeaderHeight,
  } = topOffsetElements;

  if (isMobile()) {
    return eulaHeaderHeight + staticNotificationHeight;
  }

  const heightSum =
    headerHeight +
    primaryNavigationHeight +
    staticNotificationHeight +
    eulaHeaderHeight;
  const underTheMenuOffset = heightSum - window.scrollY;
  const defaultOffset = DEFAULT_NOTIFICATION_OFFSET + eulaHeaderHeight;

  return underTheMenuOffset < defaultOffset
    ? defaultOffset
    : underTheMenuOffset;
};

export function getFooterHeightInView(): number {
  const footerEl = document.getElementsByClassName(FOOTER_CLASS_NAME)[0];
  const { top } = footerEl.getBoundingClientRect();

  const heightInView = window.innerHeight - top;

  return heightInView < 0 ? 0 : heightInView;
}
